import { getProductByCode, getProductsByAccountId } from "apis/orderApi";
import {
  deleteWidgetByCode,
  getWidgetByCode,
  getWidgets,
  postRequestWidgetCreation,
  putWidgetShareEmail
} from "apis/widgetApi";
import { doCall } from "common/genericSaga";
import { getCurrentVendor } from "helpers/vendorHelper";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import { oidc } from "services/oidcService";
import {
  receiveProduct,
  receiveSendWidgetShareEmail,
  receiveWidget,
  receiveWidgetCreation,
  receiveWidgetDelete,
  receiveWidgetProducts,
  receiveWidgetWidgets,
  WIDGETS_REQUESTED,
  WIDGETS_REQUEST_FAILED,
  WIDGET_BY_CODE_REQUESTED,
  WIDGET_BY_CODE_REQUEST_FAILED,
  WIDGET_CREATION_REQUESTED,
  WIDGET_CREATION_REQUEST_FAILED,
  WIDGET_DELETE_REQUESTED,
  WIDGET_DELETE_REQUEST_FAILED,
  WIDGET_PRODUCT_BY_CODE_REQUESTED,
  WIDGET_PRODUCT_BY_CODE_REQUEST_FAILED,
  WIDGET_SEND_EMAIL_REQUESTED,
  WIDGET_SEND_EMAIL_REQUEST_FAILED
} from "./widgetActions";

export function* doRequestWidgetCreation(action, requestInfo) {
  yield call(postRequestWidgetCreation, requestInfo, action.id);
  yield put(receiveWidgetCreation(action.id));
  const widget = yield call(getWidgetByCode, requestInfo, action.id);
  yield put(receiveWidget(action.id, widget));
}

export function* doRequestWidget(action, requestInfo) {
  const widget = yield call(getWidgetByCode, requestInfo, action.id);
  yield put(receiveWidget(action.id, widget));
}

export function* doRequestWidgetDelete(action, requestInfo) {
  yield call(deleteWidgetByCode, requestInfo, action.payload.productCode);
  yield put(receiveWidgetDelete(action.payload.productCode));
}

export function* doRequestWidgetSendEmail(action, requestInfo) {
  yield call(
    putWidgetShareEmail,
    requestInfo,
    action.id,
    action.payload.vendorId,
    action.payload.SenderName,
    action.payload.RecipientEmail,
    action.payload.PersonalMessage || ""
  );
  yield put(receiveSendWidgetShareEmail(action.id));
}

export function* doRequestWidgets(action, requestInfo) {
  const channels = yield select(state => state.merchandise);
  const currentVendor = yield call(getCurrentVendor);
  const currentChannel = Object.values(channels).find(c => c.ID === currentVendor);

  const photobookPapIds = currentChannel.Articles.filter(
    a => a.ArticleType && a.ArticleType.toLowerCase().includes("photobook")
  ).map(a => a.ID);

  const accountId = yield call(oidc.getCurrentUserAccountId);
  const offset = (action.pageNumber - 1) * action.pageSize;

  const productsResponse = yield call(
    getProductsByAccountId,
    requestInfo,
    accountId,
    photobookPapIds,
    offset,
    action.pageSize
  );

  if (!productsResponse.items.length) {
    yield put(
      receiveWidgetProducts(action.pageSize, action.pageNumber, productsResponse.total, productsResponse.items)
    );
    return;
  }

  const widgetsResponse = yield call(
    getWidgets,
    requestInfo,
    productsResponse.items.map(i => i.code)
  );

  const widgets = productsResponse.items.map(
    i => widgetsResponse.find(w => w.productCode === i.code) || { productCode: i.code }
  );

  yield put(receiveWidgetWidgets(widgets));
  yield put(receiveWidgetProducts(action.pageSize, action.pageNumber, productsResponse.total, productsResponse.items));
}

export function* doRequestProductByCode(action, requestInfo) {
  const product = yield call(getProductByCode, requestInfo, action.id);
  yield put(receiveProduct(product));
}

export function* watchWidget() {
  yield all([
    takeEvery(WIDGET_CREATION_REQUESTED, doCall(doRequestWidgetCreation, WIDGET_CREATION_REQUEST_FAILED)),
    takeEvery(WIDGET_BY_CODE_REQUESTED, doCall(doRequestWidget, WIDGET_BY_CODE_REQUEST_FAILED)),
    takeEvery(WIDGETS_REQUESTED, doCall(doRequestWidgets, WIDGETS_REQUEST_FAILED)),
    takeEvery(WIDGET_DELETE_REQUESTED, doCall(doRequestWidgetDelete, WIDGET_DELETE_REQUEST_FAILED)),
    takeEvery(WIDGET_SEND_EMAIL_REQUESTED, doCall(doRequestWidgetSendEmail, WIDGET_SEND_EMAIL_REQUEST_FAILED)),
    takeEvery(WIDGET_PRODUCT_BY_CODE_REQUESTED, doCall(doRequestProductByCode, WIDGET_PRODUCT_BY_CODE_REQUEST_FAILED))
  ]);
}
